import Yup from '~/utils/validations/yup';

export const schemaValidator = Yup.object().shape({
  amount: Yup.number()
    .required('This field is required')
    .min(1, 'This field is required'),
  date: Yup.date().required(),
});
